var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgSavemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93 4.4C1.93 2.5 3.48.93 5.38.93h7.24a3.48 3.48 0 0 1 3.46 3.45v10.57c0 .8-.29 1.51-.9 1.88-.63.36-1.39.27-2.09-.12L9.43 14.7a.9.9 0 0 0-.42-.1.93.93 0 0 0-.43.1l-3.66 2.03c-.7.39-1.47.48-2.08.11-.62-.36-.91-1.07-.91-1.87V4.4Zm3.45-2.34A2.34 2.34 0 0 0 3.05 4.4v10.57c0 .55.2.8.36.9.16.1.48.14.96-.12l3.66-2.03c.3-.17.65-.24.98-.24a2 2 0 0 1 .97.24l3.66 2.03c.48.27.8.22.96.13.16-.1.36-.35.36-.9V4.4a2.35 2.35 0 0 0-2.35-2.34H5.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgSavemedium);
export default __webpack_public_path__ + "static/media/igSave.medium.e186810a97daebff705583a1088fed9f.svg";
export { ForwardRef as ReactComponent };